import { defineMessages } from 'react-intl';

export default defineMessages({
  errorProcessingFile: {
    id: 'additionalInformation.errorProcessingFile',
    defaultMessage: 'Error processing file',
  },
  fileUploadedSuccessfully: {
    id: 'components.additionalInformation.fileUploadedSuccessfully',
    defaultMessage: 'File uploaded successfully',
  },
});
